import React, { useState, useEffect } from 'react';
import { FaChevronDown, FaCheck } from 'react-icons/fa';

const AdvancedSelectForCreate = ({
  options = [],
  placeholder = 'Select...',
  minCountText = 2,
  onChange = () => {},
  defaultValue = [],
}) => {
  const [selected, setSelected] = useState(defaultValue);
  const [isOpen, setIsOpen] = useState(false);

  // Sync defaultValue when it changes
  useEffect(() => {
    setSelected(defaultValue);
  }, [defaultValue]);

  const toggleOption = (option) => {
    let newSelected;
    if (selected.includes(option)) {
      newSelected = selected.filter((item) => item !== option);
    } else {
      newSelected = [...selected, option];
    }
    setSelected(newSelected);
    onChange(newSelected);
  };

  const clearAll = () => {
    setSelected([]);
    onChange([]);
  };

  const isSelected = (option) => selected.includes(option);

  const renderToggleText = () => {
    if (selected.length === 0) return placeholder;
    if (selected.length > minCountText) {
      return `${selected.slice(0, minCountText).join(', ')} +${selected.length - minCountText}`;
    }
    return selected.join(', ');
  };

  return (
    <div className="relative max-w-sm w-full">
      <button
        type="button"
        className="advance-select-toggle w-full border px-4 py-2 rounded-md flex items-center justify-between relative"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{renderToggleText()}</span>
        <FaChevronDown className="w-4 h-4 text-gray-500 absolute right-3 top-1/2 -translate-y-1/2" />
      </button>

      {isOpen && (
        <div className="advance-select-menu mt-2 border max-h-44 overflow-y-auto rounded-md shadow-md absolute w-full bg-white z-10">
          {options.map((option) => (
            <div
              key={option}
              className={`advance-select-option px-4 py-2 flex justify-between items-center cursor-pointer hover:bg-gray-100 ${
                isSelected(option) ? 'bg-gray-100' : ''
              }`}
              onClick={() => {
                toggleOption(option);
              }}
            >
              <span>{option}</span>
              {isSelected(option) && <FaCheck className="w-4 h-4 text-primary" />}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdvancedSelectForCreate;